import type { HelpFile } from '../../types/help'
import { RestrictionRuleRequestDetailTestIds } from '../../../testids/RestrictionRuleRequestDetailTestIds'

export const restrictionRuleRequestDetailHelp: HelpFile = {
  docPage: '/docs/governance/restriction-rule-requests',
  texts: {
    [RestrictionRuleRequestDetailTestIds.restrictionRuleRequestDetailPage]:
      'Restriktionsregel-Änderungsantrag — vorgeschlagene Konfiguration, Genehmigungsworkflow und Lifecycle-Aktionen.',
    [RestrictionRuleRequestDetailTestIds.approvalChainCard]:
      'Genehmigungskette — jeder Schritt, die zugewiesenen Genehmigenden und ihre Entscheidungen.',
    [RestrictionRuleRequestDetailTestIds.approvalChainEmpty]:
      'Noch keine Genehmigenden ermittelt — in der Regel vor dem Einreichen.',
    [RestrictionRuleRequestDetailTestIds.cardLinkedRule]:
      'Die Restriktionsregel, die dieser Antrag ändert, oder ein Hinweis auf einen CREATE-Antrag.',
    [RestrictionRuleRequestDetailTestIds.cardProposedConfig]:
      'Vorgeschlagene Restriktionsregel-Konfiguration — Bedingung, verbotene Profile und Karenzzeit.',
    [RestrictionRuleRequestDetailTestIds.cardRequestInfo]:
      'Antragszusammenfassung: Antragsteller, Typ, Status und Zeitstempel.',
    [RestrictionRuleRequestDetailTestIds.cardTestPanel]:
      'Vorgeschlagene Bedingung gegen Live-Identitätsdaten ausführen und aggregierte Zähler einsehen.',
    [RestrictionRuleRequestDetailTestIds.cardTitleApprovalChain]: null,
    [RestrictionRuleRequestDetailTestIds.cardTitleLinkedRule]: null,
    [RestrictionRuleRequestDetailTestIds.cardTitleProposedConfig]: null,
    [RestrictionRuleRequestDetailTestIds.cardTitleTestPanel]: null,
    [RestrictionRuleRequestDetailTestIds.btnEdit]:
      'Vorgeschlagene Konfiguration bearbeiten, solange der Antrag noch ein Entwurf ist.',
    [RestrictionRuleRequestDetailTestIds.btnDelete]:
      'Antrag löschen — kann nicht rückgängig gemacht werden.',
    [RestrictionRuleRequestDetailTestIds.btnRunTest]:
      'Vorgeschlagene Regel gegen Live-Identitätsdaten testen.',
    [RestrictionRuleRequestDetailTestIds.btnSubmitForApproval]:
      'Entwurf einreichen, um den Genehmigungsworkflow zu starten.',
    [RestrictionRuleRequestDetailTestIds.btnCancelRequest]:
      'Antrag vor der Genehmigung abbrechen — kann nicht rückgängig gemacht werden.',
    [RestrictionRuleRequestDetailTestIds.colProfileName]: null,
    [RestrictionRuleRequestDetailTestIds.errorRejectComment]:
      'Ablehnungskommentar fehlt oder ist ungültig.',
    [RestrictionRuleRequestDetailTestIds.linkLinkedRule]:
      'Restriktionsregel öffnen, die dieser Antrag ändert.',
    [RestrictionRuleRequestDetailTestIds.linkOwnerParty]:
      'Detailseite des Antragstellers oder der besitzenden Partei öffnen.',
    [RestrictionRuleRequestDetailTestIds.linkedRuleEmpty]:
      'CREATE-Antrag — noch keine bestehende Regel verknüpft.',
    [RestrictionRuleRequestDetailTestIds.requestTypeBadge]:
      'Art der vorgeschlagenen Änderung — anlegen, aktualisieren, löschen, aktivieren oder deaktivieren.',
    [RestrictionRuleRequestDetailTestIds.textareaApproveComment]:
      'Optionaler Kommentar zur Genehmigungsentscheidung.',
    [RestrictionRuleRequestDetailTestIds.textareaRejectComment]:
      'Begründung der Ablehnung.',
  },
}
